import {createContext} from "react";

export const ConfigContext = createContext(null);

export const ObjectivesContext = createContext(null);